import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  OnInit,
} from '@angular/core';
import { IconRegistryService } from '@rd/core/services/icon-registry/icon-registry.service';
import { DialogConfig } from '@rd/popup/dialog-config';
import { DialogRef } from '@rd/popup/dialog-ref';
import { PopupSettingService } from '@rd/popup/services/popup-setting/popup-setting.service';
import { ButtonTheme } from '@rd/types';

export interface MembershipFailDialogConfig {
  context: 'number';
}

@Component({
  selector: 'rd-tcv2-membership-fail-dialog',
  templateUrl: './membership-fail-dialog.component.html',
  styleUrls: ['./membership-fail-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TcV2MembershipFailDialogComponent implements OnInit {
  @HostBinding('class.rd-tcv2-membership-fail-dialog') componentClass = true;

  context: 'number';
  loyaltyProgramShortName: string;

  constructor(
    private dialogRef: DialogRef,
    private dialogConfig: DialogConfig<{
      context: 'number';
      loyaltyProgramShortName?: string;
    }>,
    private iconRegistryService: IconRegistryService,
    private popupSettingService: PopupSettingService,
  ) {
    // @ts-ignore
    this.context = this.dialogConfig.data.context;
    // @ts-ignore
    this.loyaltyProgramShortName =
      // @ts-ignore
      this.dialogConfig.data.loyaltyProgramShortName;
  }

  ngOnInit(): void {
    this.registerIcons();
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  get descriptionTranslationKey(): string {
    return 'transfer_v2.membership_fail_dialog.number_description';
  }

  get titleTranslationKey(): string {
    return 'transfer_v2.membership_fail_dialog.number_title';
  }

  get buttonTheme(): ButtonTheme {
    return this.popupSettingService.singleButtonTheme;
  }

  private registerIcons(): void {
    this.iconRegistryService.registerIcon('account-linking-failed');
  }
}
